import React from 'react';
import { motion } from 'framer-motion';

/**
 * AnimatedCard - Non-breaking wrapper for card animations
 * Wraps existing cards with smooth entrance animations
 * Preserves all children props and functionality
 */
const AnimatedCard = ({ 
  children, 
  delay = 0, 
  className = '',
  hover = true,
  ...props 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.5, 
        delay,
        ease: [0.4, 0, 0.2, 1]
      }}
      whileHover={hover ? { 
        y: -4, 
        transition: { duration: 0.2 }
      } : undefined}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedCard;
